import { useDispatch, useSelector } from "react-redux"
import {
    useFetchWithBody,
    usePost,
} from "../../../api/reactQueryCustomHooks"
import { apiRoute, CHALLAN_TYPE, decryptText, ENUM_ADVSEARCH_PARAM, ENUM_BILL_TYPE, ENUM_CURRENCY_SETTING_VAL, ENUM_ENTRY_TYPE, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_PAGEACTION_TYPE, ENUM_TRADEOF_CODE, ENUM_TRADEOF_TYPE, funGetFormatCurrency, GetLoginCredentialDb, getModMandatory, getModValue, linksUrl, SALE_PUR_ENTRY_TYPE, URIEncrypt } from "../../../constants/enum"
import {
    ErrorCard,
    LoadingCard,
    MainContainer,
    NextUITable,
} from "../../../components"
import {
    Autocomplete,
    AutocompleteItem,
    Button,
    form,
    Input,
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    useDisclosure,
} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    faClose,
    faEdit,
    faPlus,
    faPrint,
    faReceipt,
    faTrash,
} from "@fortawesome/free-solid-svg-icons"

import {
    COLUMN_ALIGN_TYPE,
    COLUMN_TYPE,
    FOOTER_TYPE,
    ROW_ACTION_BTN_TYPE,
} from "../../../components/NextUITable"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { calculateTotal, formatCurrency } from "../../../Utility/utility"
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { Drawer, FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { useModalToast } from "../../../components/modalToast/ModalToastContext"

const InvoiceEntryMaster = () => {
    let disapatch = useDispatch()
    let navigate = useNavigate()
    const { compCode, isMultipleCompany, yearId, CurrencyFormatBy } = useSelector((state) => state.company)
    const { user, token } = useSelector((state) => state.auth)
    const [selBillType, setSelBillType] = useState("S")
    const [selTradeOf, setSelTradeOf] = useState("")
    const [selPktType, setSelPktType] = useState("ALL")
    const [selStatus, setSelStatus] = useState("")
    const [selTradeType, setSelTradeType] = useState("EXP")
    const [selAdvanceFilter, setSelAdvanceFilter] = useState({})
    const [pageApiAdvFilter, setPageApiAdvFilter] = useState({})
    const [CurrencySetting, setCurrencySetting] = useState("")
    const [selStockAt, setSelStockAt] = useState("")
    const [openDrawer, setOpenDrawer] = useState(false);
    const [selFilterDate, setSelFilterDate] = useState({
        fromDate: dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD") || null,
        toDate: dayjs(new Date()).format("YYYY-MM-DD") || null

    });
    const [data, setData] = useState([])
    const { show } = useModalToast();
    const formField = {
        transId: "transId",
        billType: 'billType',
        billNo: 'billNo',
        shipmentNo: 'shipmentNo',
        shipmentDate: 'shipmentDate',
        fobAmt: 'fobAmt',
        fobAmtD: 'fobAmtD'
    }
    const [formData, setFormData] = useState({
        [formField.transId]: 0,
        [formField.billType]: '',
        [formField.billNo]: '',
        [formField.shipmentNo]: '',
        [formField.shipmentDate]: null,
        [formField.fobAmt]: 0,
        [formField.fobAmtD]: 0
    })
    const {
        isOpen: isOpenReportModel,
        onOpen: onOpenReportModel,
        onOpenChange: onOpenReportModelChange,
    } = useDisclosure()

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard)

    }, [])

    useEffect(() => {
        funFilterData(selBillType, selTradeOf, selPktType, selStockAt, selTradeType, null, null, null, null, null, null, null, null,
            selFilterDate?.fromDate, selFilterDate?.toDate, null, null, null);
        setPageApiAdvFilter({ CompCode: compCode.join(','), BillType: selBillType, TradeOf: selTradeOf })
    }, [])

    const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
        url: apiRoute.modSetting.getModSetting,
        queryKey: "fetchModSettingCurrency",
        inputData: {
            mod_name: ENUM_MOD_NAME.GeneralSettings
        }
    })


    // useEffect(() => {
    //     if (modSetting && modSetting.length > 0) {
    //         const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, modSetting);
    //         setIsUseMfgNoAsMktno(mktSetting)
    //         const currSetting = getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, modSetting) ?? ENUM_CURRENCY_SETTING_VAL.RS;
    //         setCurrencySetting(currSetting)

    //         const dStkAt = getModValue(ENUM_MOD_PARAMETER.GeneralSetting.DefaultStockDiv, modSetting);
    //         setDefaultStkAt(dStkAt)
    //         // if (selStockAt == "" || selStockAt == null)
    //         setSelStockAt(dStkAt)
    //     }
    // }, [modSetting])

    const {
        isError,
        isPending,
        data: billData = [],
        mutate: filterData
    } = usePost({
        url: apiRoute.invoiceEntry.getBillofData,
        queryKey: "Invoice Data List",
        onSuccessTasks: (data) => {
            console.log("succes")
            setData(data)
        }

    })

    const {
        isError: isErrorUpdate,
        isPending: isPendingUpdate,
        mutate: funUpdate
    } = usePost({
        url: apiRoute.invoiceEntry.updateBillOf,
        queryKey: "Invoice Data List",
        onSuccessTasks: (data) => {
            show("Updated Successfully");
            setOpenDrawer(false)
            funFilterData(selBillType, selTradeOf, selPktType, selStockAt, selTradeType, null, null, null, null, null, null, null, null,
                selFilterDate?.fromDate, selFilterDate?.toDate, selStatus, null, null);
        }

    })

    const funFilterData = (billtype, tradeof, pkttype, lac_id, tradetype, scode, qcode, szcode, shcode, lwcode, itemcode, pacid, brid, fromdate, todate, status, fduedate, tduedate) => {
        console.log("hi")
        filterData({
            data: {
                compcode: compCode.join(","),
                billtype: billtype,
                tradeof: tradeof,
                pkttype: pkttype,
                lac_id: null,
                s_code: scode,
                q_code: qcode,
                sh_code: shcode,
                sz_code: szcode,
                lw_code: lwcode,
                item_code: itemcode,
                pac_id: pacid,
                br_id: brid,
                from_date: fromdate,
                to_date: todate,
                status: status,
                fdue_date: fduedate,
                tdue_date: tduedate,
                trade_type: billtype == 'S' ? 'EXP' : billtype == 'P' ? 'IMP' : '',
            }
        })

    }




    let totalAmt = useMemo(
        () => {
            const total = calculateTotal({
                data: data,
                columnName: "Invoice_Amount",
            })
            return CurrencyFormatBy && CurrencyFormatBy != "" ? funGetFormatCurrency(total, CurrencyFormatBy) : total
        },
        [data]
    )
    let totalAmtD = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "Invoice_AmountD",
            }),
        [data]
    )
    const inputBoxes = {
        Row1: [
            {
                id: formField.shipmentNo,
                name: formField.shipmentNo,
                placeholder: "Shipment No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.shipmentDate,
                name: formField.shipmentDate,
                placeholder: "Shipment Date.",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: false,
            },],
        Row2: [
            {
                id: formField.fobAmt,
                name: formField.fobAmt,
                placeholder: "Ass. Value",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.fobAmtD,
                name: formField.fobAmtD,
                placeholder: "Ass. Value ($)",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },],
    }
    const INITIAL_VISIBLE_COLUMNS = [
        "actions",
        "Party_Name",
        "Invoice_No",
        "Invoice_Date",
        "Invoice_Amount",
        "Invoice_AmountD",
        "Shipment_No",
        "Shipment_Date",
        "Fob_Amt",
        "Fob_AmtD",
        "status"


    ]
    const [initialColumn, setInitialColumn] = useState(INITIAL_VISIBLE_COLUMNS)

    const exportColumns = [
        {
            name: "PARTY NAME",
            uid: "Party_Name",
        },

        {
            name: "INVOICE NO",
            uid: "Invoice_No",
        },
        {
            name: "INVOICE DATE",
            uid: "Invoice_Date",
            type: COLUMN_TYPE.date,
        },

        {
            name: "AMOUNT",
            uid: "Invoice_Amount",
            type: COLUMN_TYPE.number,
        },
        {
            name: "AMOUNT($)",
            uid: "Invoice_AmountD",
            type: COLUMN_TYPE.number,
        },
        {
            name: "SHIPMENT No",
            uid: "Shipment_No",
        },
        {
            name: "SHIPMENT DATE",
            uid: "Shipment_Date",
            type: COLUMN_TYPE.date,
        },

        {
            name: "FOB AMT($)",
            uid: "Fob_AmtD",
            type: COLUMN_TYPE.number
        },
        {
            name: "FOB AMT",
            uid: "Fob_Amt",
            type: COLUMN_TYPE.number
        },
        {
            name: "STATUS",
            uid: "status",
        },


    ]
    const [exportCols, setExportCols] = useState(exportColumns)
    let downloadDataFooter = {

        Party_Name: "",
        Invoice_No: "",
        Invoice_Date: "",
        Invoice_Amount: "Total: " + totalAmt,
        Invoice_AmountD: "Total: " + totalAmtD,
        Shipment_No: "",
        Shipment_Date: "",
        Fob_AmtD: "",
        Fob_AmtD: "",
        status: ""
    }

    const [exportFooter, setExportFooter] = useState(downloadDataFooter)
    // useEffect(() => {
    //     if (CurrencySetting && CurrencySetting != "") {
    //         let AmtColumn = []
    //         if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS)
    //             AmtColumn = ["Invoice_AmountD", "AvgRateD", "C_Rate"]
    //         else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar)
    //             AmtColumn = ["Invoice_Amount", "AvgRate"]
    //         else {
    //             setInitialColumn(INITIAL_VISIBLE_COLUMNS)
    //             setExportFooter(downloadDataFooter)
    //             setExportCols(exportColumns)
    //         }

    //         if (AmtColumn.length > 0) {
    //             const filterIniCol = initialColumn.filter(ele => ele != AmtColumn)
    //             const filterExpCol = exportColumns.filter((ele) => ele.uid != AmtColumn)
    //             //let footerCol = AmtColumn == 'Invoice_AmountD' ? 'Amount$' : 'Amount'
    //             const filterExpFooter = Object.keys(downloadDataFooter).filter((ele) => !AmtColumn.includes(ele))
    //             setExportCols(filterExpCol)
    //             setInitialColumn(filterIniCol)
    //             setExportFooter(filterExpFooter)

    //         }
    //     }
    // }, [CurrencySetting])


    const columns = [
        {
            name: "Actions",
            uid: "actions",
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "PARTY NAME",
            uid: "Party_Name",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "INVOICE NO",
            uid: "Invoice_No",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "DATE",
            uid: "Invoice_Date",
            type: COLUMN_TYPE.date,
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
        },
        {
            name: "AMOUNT",
            uid: "Invoice_Amount",
            align: COLUMN_ALIGN_TYPE.center,
            type: CurrencyFormatBy && CurrencyFormatBy != "" ? COLUMN_TYPE.formatedCurrency : COLUMN_TYPE.currency,
            sortable: true,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: formatCurrency(totalAmt),
            },
        },
        {
            name: "AMOUNT($)",
            uid: "Invoice_AmountD",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            type: COLUMN_TYPE.number,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalAmtD,
            },
        },
        {
            name: "Ship No.",
            uid: "Shipment_No",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,

        },
        {
            name: "Ship DATE",
            uid: "Shipment_Date",
            type: COLUMN_TYPE.date,
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
        },
        {
            name: "Ass. Value($)",
            uid: "Fob_AmtD",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            type: COLUMN_TYPE.number,

        },
        {
            name: "Ass. Value",
            uid: "Fob_Amt",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            type: COLUMN_TYPE.number,

        },
        {
            name: "Status",
            uid: "status",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,

        },



    ]



    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon color="#f3f7f2" icon={faEdit} />,
            onClick: (row) => {
                let obj = {
                    comp_code: row.CompCode,
                    transaction_id: row.TransactionId,
                    bill_type: row.Bill_Type,
                    trade_of: row.Trade_Of,
                    status: row.status

                }
                setFormData({
                    ...formData, [formField.transId]: row?.TransactionId,
                    [formField.billType]: row?.Bill_Type,
                    [formField.billNo]: row?.Invoice_No || '',
                    [formField.shipmentNo]: row?.Shipment_No || '',
                    [formField.shipmentDate]: row?.Shipment_Date || null,
                    [formField.fobAmt]: row?.Fob_Amt || 0,
                    [formField.fobAmtD]: row?.Fob_AmtD || 0
                })

                setOpenDrawer(true)

            },
            type: ROW_ACTION_BTN_TYPE.button,
            label: 'Update Bill Of'
        },

    ]

    const compactSelectSx = {
        height: 36,
        borderRadius: "8px",
        backgroundColor: "#fff",
        fontSize: "13px",
        "& .MuiSelect-select": {
            padding: "8px 10px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#c7d2fe",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#818cf8",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#4f46e5",
            borderWidth: "1.5px",
        },
    };

    const datePickerSx = {
        width: "100%",
        "& .MuiOutlinedInput-root": {
            height: 36,
            borderRadius: "8px",
            backgroundColor: "#fff",
            fontSize: "12px",
            "& fieldset": {
                borderColor: "#c7d2fe",
            },
            "&:hover fieldset": {
                borderColor: "#818cf8",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#4f46e5",
                borderWidth: "1.5px",
            },
        },
        "& .MuiInputBase-input": {
            fontSize: "12px",
            fontWeight: 500,
            color: "#334155",
            padding: "8px 8px",
        },
        "& .MuiInputLabel-root": {
            fontSize: "14px",
            fontWeight: 600,
            color: "#475569",
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: "#4f46e5",
        },
        "& .MuiSvgIcon-root": {
            fontSize: "18px",
            color: "#6366f1",
        },
    };




    const ADVFILTER_VISIBLE_FIELD = [
        //...Object.values(ENUM_ADVSEARCH_PARAM)
        ENUM_ADVSEARCH_PARAM.Shape,
        ENUM_ADVSEARCH_PARAM.Purity,
        ENUM_ADVSEARCH_PARAM.Color,
        ENUM_ADVSEARCH_PARAM.Size,
        ENUM_ADVSEARCH_PARAM.Party,
        ENUM_ADVSEARCH_PARAM.Broker,
        ENUM_ADVSEARCH_PARAM.Item,
        ENUM_ADVSEARCH_PARAM.LwRatio,
        ENUM_ADVSEARCH_PARAM.VouFromDate,
        ENUM_ADVSEARCH_PARAM.VouToDate,
        ENUM_ADVSEARCH_PARAM.DueToDate,
        ENUM_ADVSEARCH_PARAM.DueFromDate,
        //ENUM_ADVSEARCH_PARAM.Status,
        //ENUM_ADVSEARCH_PARAM.VouNo,
    ]
    const handleFilterChange = (newFilters) => {
        //console.log('Received filters in parent:', newFilters);
        setSelAdvanceFilter(newFilters)
        funFilterData(selBillType, selTradeOf, selPktType, selStockAt, selTradeType,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Shape) ? newFilters[ENUM_ADVSEARCH_PARAM.Shape] : null,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Purity) ? newFilters[ENUM_ADVSEARCH_PARAM.Purity] : null,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Size) ? newFilters[ENUM_ADVSEARCH_PARAM.Size] : null,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Color) ? newFilters[ENUM_ADVSEARCH_PARAM.Color] : null,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.LwRatio) ? newFilters[ENUM_ADVSEARCH_PARAM.LwRatio] : null,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Item) ? newFilters[ENUM_ADVSEARCH_PARAM.Item] : null,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Party) ? newFilters[ENUM_ADVSEARCH_PARAM.Party] : null,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Broker) ? newFilters[ENUM_ADVSEARCH_PARAM.Broker] : null,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.VouFromDate) ? newFilters[ENUM_ADVSEARCH_PARAM.VouFromDate] : null,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.VouToDate) ? newFilters[ENUM_ADVSEARCH_PARAM.VouToDate] : null,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Status) ? newFilters[ENUM_ADVSEARCH_PARAM.Status] : null,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.DueFromDate) ? newFilters[ENUM_ADVSEARCH_PARAM.DueFromDate] : null,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.DueToDate) ? newFilters[ENUM_ADVSEARCH_PARAM.DueToDate] : null,

        )

    };
    const handleFilter = () => {
        funFilterData(selBillType, selTradeOf, selPktType, selStockAt, selTradeType, null, null, null, null, null, null, null, null,
            selFilterDate?.fromDate, selFilterDate?.toDate, selStatus, null, null);

    }
    const handleClear = () => {
        const fDate = dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD") || null
        const tDate = dayjs(new Date()).format("YYYY-MM-DD") || null
        setSelFilterDate({
            fromDate: fDate,
            toDate: tDate

        });
        setSelTradeOf("")
        setSelBillType("S")
        setSelTradeType("EXP")
        setSelPktType("ALL")
        setSelStatus("")
        funFilterData('S', "", 'ALL', selStockAt, 'EXP', null, null, null, null, null, null, null, null,
            fDate, tDate, null, null, null);
    }
    const handleAutoCompleteChange = (value, id, name) => {
    }

    const handleChange = (e) => {
        const { name, value } = e.target

        setFormData({ ...formData, [name]: value })
    }
    const handleDateBlur = (e, name) => {
        const input = e.target.value.trim();   // "DD/MM/YYYY"

        if (!input) return;

        // Parse typed date strictly as DD/MM/YYYY
        const parsed = dayjs(input, "DD/MM/YYYY", true);
        // Convert to API format
        const formatted = parsed.format("YYYY-MM-DD");

        setFormData(prev => {
            const updated = { ...prev, [name]: formatted };
            return updated;
        });

    };
    const handleDateChange = (newValue) => {

        const cdate = newValue != '' && newValue != 'Invalid Date' ? dayjs(newValue).format("YYYY-MM-DD") : null

        setFormData((prev) => {
            return {
                ...prev,
                shipmentDate: cdate,
            };
        });

    }
    const handleSubmit = (e) => {
        e.preventDefault()
        console.log(formData, "df")
        funUpdate({
            data: {
                compcode: compCode.join(","),
                billtype: selBillType,
                bill_no: formData.billNo,
                transid: formData.transId,
                ship_no: formData.shipmentNo,
                ship_date: formData.shipmentDate,
                fob_amt: formData.fobAmt,
                fob_amtd: formData.fobAmtD
            }
        })

    }
    const handleBillChange = (e) => {
        const { name, value } = e.target
        setSelBillType(value)
        setData([])
        setSelTradeType(value == "P" ? 'IMP' : 'EXP')

    }
    if (isError) {
        return <ErrorCard />
    }

    if (isPending) {
        return <LoadingCard />
    }
    return (
        <div>


            <MainContainer
                pageName={'Bill of Entry'}
                info={[]}
                breadcrumbs={['Accounts', 'Bill of Entry']}
            >




                <div className="mb-4 rounded-xl border border-indigo-100 bg-gradient-to-r from-indigo-50 via-white to-blue-50 p-3 shadow-sm">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <div className="flex flex-wrap items-end justify-end gap-3">

                            {/* Bill Type - Compact */}
                            <div className="w-full shrink-0 sm:w-28">
                                <FormControl fullWidth size="small">
                                    <InputLabel
                                        id="bill-type-label"
                                        sx={{ fontSize: "14px", fontWeight: 600 }}
                                    >
                                        Bill Type
                                    </InputLabel>

                                    <Select
                                        labelId="bill-type-label"
                                        name="billType"
                                        value={selBillType}
                                        label="Bill Type"
                                        onChange={handleBillChange}
                                        sx={compactSelectSx}
                                    >
                                        <MenuItem value="S">Sale</MenuItem>
                                        <MenuItem value="P">Purchase</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>

                            {/* From Date */}
                            <div className="w-full shrink-0 sm:w-40">
                                <DatePicker
                                    label="Bill Date From"
                                    views={["day", "month", "year"]}
                                    format="DD/MM/YYYY"
                                    value={
                                        selFilterDate.fromDate
                                            ? dayjs(selFilterDate.fromDate)
                                            : null
                                    }
                                    onChange={(newValue) => {
                                        setSelFilterDate((prev) => ({
                                            ...prev,
                                            fromDate:
                                                newValue?.isValid()
                                                    ? newValue.format("YYYY-MM-DD")
                                                    : null,
                                        }));
                                    }}
                                    slotProps={{
                                        field: {
                                            clearable: true,
                                        },
                                        textField: {
                                            fullWidth: true,
                                            size: "small",
                                            sx: datePickerSx,
                                        },
                                    }}
                                />
                            </div>

                            {/* To Date */}
                            <div className="w-full shrink-0 sm:w-40">
                                <DatePicker
                                    label="Bill Date To"
                                    views={["day", "month", "year"]}
                                    format="DD/MM/YYYY"
                                    value={
                                        selFilterDate.toDate
                                            ? dayjs(selFilterDate.toDate)
                                            : null
                                    }
                                    onChange={(newValue) => {
                                        setSelFilterDate((prev) => ({
                                            ...prev,
                                            toDate:
                                                newValue?.isValid()
                                                    ? newValue.format("YYYY-MM-DD")
                                                    : null,
                                        }));
                                    }}
                                    slotProps={{
                                        field: {
                                            clearable: true,
                                        },
                                        textField: {
                                            fullWidth: true,
                                            size: "small",
                                            sx: datePickerSx,
                                        },
                                    }}
                                />
                            </div>

                            {/* Trade Of */}
                            <div className="w-full shrink-0 sm:w-40">
                                <FormControl fullWidth size="small">
                                    <InputLabel
                                        id="trade-of-label"
                                        sx={{ fontSize: "12px", fontWeight: 600 }}
                                    >
                                        Trade Of
                                    </InputLabel>

                                    <Select
                                        labelId="trade-of-label"
                                        name="tradeOf"
                                        value={selTradeOf}
                                        label="Trade Of"
                                        onChange={(e) =>
                                            setSelTradeOf(e.target.value)
                                        }
                                        sx={compactSelectSx}
                                    >
                                        <MenuItem value="P">Polish</MenuItem>
                                        <MenuItem value="R">Rough</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>

                            {/* Packet Type - Compact */}
                            <div className="w-full shrink-0 sm:w-32">
                                <FormControl fullWidth size="small">
                                    <InputLabel
                                        id="packet-type-label"
                                        sx={{ fontSize: "14px", fontWeight: 600 }}
                                    >
                                        Packet Type
                                    </InputLabel>

                                    <Select
                                        labelId="packet-type-label"
                                        name="PacketType"
                                        value={selPktType}
                                        label="Packet Type"
                                        onChange={(e) =>
                                            setSelPktType(e.target.value)
                                        }
                                        sx={compactSelectSx}
                                    >
                                        <MenuItem value="ALL">ALL</MenuItem>
                                        <MenuItem value="SNG">Single</MenuItem>
                                        <MenuItem value="MIX">Mix</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="w-full shrink-0 sm:w-32">
                                <FormControl fullWidth size="small">
                                    <InputLabel
                                        id="packet-type-label"
                                        sx={{ fontSize: "12px", fontWeight: 600 }}
                                    >
                                        Status
                                    </InputLabel>

                                    <Select
                                        labelId="packet-type-label"
                                        name="statusType"
                                        value={selStatus}
                                        label="Packet Type"
                                        onChange={(e) =>
                                            setSelStatus(e.target.value)
                                        }
                                        sx={compactSelectSx}
                                    >
                                        
                                        <MenuItem value="Pending">Pending</MenuItem>
                                        <MenuItem value="Final">Final</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>

                            {/* Action Buttons */}
                            <div className="flex w-full shrink-0 items-center gap-2 sm:w-auto">
                                <Button
                                    onPress={handleFilter}
                                    variant="solid"
                                    size="sm"
                                    className="h-8 min-w-20 rounded-lg bg-indigo-600 px-4 text-xs font-semibold uppercase text-white shadow-sm transition hover:bg-indigo-700 active:scale-95"
                                >
                                    Show
                                </Button>

                                <Button
                                    onPress={handleClear}
                                    variant="bordered"
                                    size="sm"
                                    className="h-8 min-w-20 rounded-lg border border-rose-200 bg-white px-4 text-xs font-semibold uppercase text-rose-600 transition hover:bg-rose-50 active:scale-95"
                                >
                                    Reset
                                </Button>
                            </div>

                        </div>
                    </LocalizationProvider>
                </div>





                <Drawer open={openDrawer} anchor="top">
                    {/* <FontAwesomeIcon onClick={() => setOpenDrawer(false)} className=" p-3 cursor-pointer text-blue-800 text-3xl absolute right-0" icon={faSquareXmark} /> */}

                    <div className="text-center font-semibold uppercase p-1 text-gray-700 border-b-2 border-orange-500">
                        Update Bill OF Entry
                    </div>
                    <div className="p-5">
                        <form onSubmit={handleSubmit}>
                            {
                                Object.keys(inputBoxes).map((key, ind) => (
                                    <div key={key + ind}>
                                        <div className={` flex gap-4 align-top items-baseline mb-2 `}>
                                            {
                                                inputBoxes[key].map((item, indx) =>
                                                    item.type == ENUM_INPUT_TYPE.select ? (
                                                        <></>
                                                    ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                        <Autocomplete
                                                            size="md"
                                                            name={item.name}
                                                            //isInvalid={errors[item.name]}
                                                            //  errorMessage={errors[item.name]}
                                                            label={item?.placeholder}
                                                            eventResizeFeature={true}
                                                            selectionMode="single"
                                                            showScrollIndicators={true}
                                                            labelPlacement={"outside"}
                                                            placeholder={item.placeholder}
                                                            isRequired={item.isrequired}
                                                            menuTrigger={"input"}
                                                            //isLoading={isPendingData}
                                                            className="max-w-23"
                                                            classNames={{
                                                                label: "text-xs text-black font-bold",
                                                            }}
                                                            isClearable={false}
                                                            isVirtualized
                                                            defaultItems={
                                                                item.data ? item.data : []
                                                            }
                                                            onSelectionChange={(e) =>
                                                                handleAutoCompleteChange(e, '', item.name)
                                                            }

                                                            selectedKey={formData[item.name]}
                                                        >
                                                            {(list) => (
                                                                <AutocompleteItem

                                                                    key={list[item.itemkey]}
                                                                >
                                                                    {list[item.itemvalue]}
                                                                </AutocompleteItem>
                                                            )}
                                                        </Autocomplete>
                                                    ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                        <div className=" w-full flex items-center">
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DatePicker
                                                                    label={item.placeholder}
                                                                    views={["day", "month", "year"]}
                                                                    format="DD/MM/YYYY"
                                                                    value={
                                                                        formData[item.name]
                                                                            ? dayjs(formData[item.name])
                                                                            : formData[item.name]
                                                                    }
                                                                    onChange={(newValue) => handleDateChange(newValue)}
                                                                    //isRequired={item.required}
                                                                    className="w-full "
                                                                    slotProps={{
                                                                        textField: { size: "small", onBlur: (e) => handleDateBlur(e, item.name), required: true },
                                                                    }}
                                                                />
                                                            </LocalizationProvider>
                                                        </div>
                                                    ) : (

                                                        <Input
                                                            type={item.type}
                                                            name={item.name}
                                                            id={item.name}
                                                            //isInvalid={errors[item.name]}
                                                            //errorMessage={errors[item.name]}
                                                            placeholder={item.placeholder}
                                                            label={item.placeholder}
                                                            labelPlacement="outside"
                                                            isRequired={item.isrequired}
                                                            value={formData[item.name]}
                                                            variant="bordered"
                                                            onChange={(e) => handleChange(e)}


                                                            size={"md"}
                                                            classNames={{
                                                                label: "text-xs text-black font-bold",
                                                            }}
                                                        ></Input>
                                                    )
                                                )
                                            }
                                        </div>
                                    </div>
                                ))
                            }

                            <div className="py-5 text-center justify-center flex gap-4">
                                <Button
                                    color="success"
                                    size="sm"
                                    variant="shadow"
                                    className="uppercase"
                                    type="submit"
                                    startContent={<FontAwesomeIcon icon={faPlus} />}
                                >
                                    Save
                                </Button>
                                <Button
                                    color="danger"
                                    size="sm"
                                    variant="shadow"
                                    className="uppercase"
                                    onPress={() => setOpenDrawer(false)}
                                    startContent={<FontAwesomeIcon icon={faClose} />}
                                >
                                    Close
                                </Button>
                            </div>
                        </form>

                    </div>


                </Drawer>

                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={initialColumn}
                    data={data}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    exportColumns={exportCols}
                    downloadDataFooter={exportFooter}
                    downloadFileName={"Bill of Entry"}
                    onFilterChange={handleFilterChange}
                    advanceFilterParam={selAdvanceFilter}
                    advFilterPageApiParam={pageApiAdvFilter}
                    advFilterVisibleField={ADVFILTER_VISIBLE_FIELD}
                    id="TransactionId"
                ></NextUITable>
            </MainContainer>
        </div>
    )
}
export default InvoiceEntryMaster
